// extracted by mini-css-extract-plugin
module.exports = {"bp-tablet-small-viewport":"(min-width: 768px)","eyebrow":"eyebrow_eyebrow__hWwRh","desktop":"eyebrow_desktop__y72RQ","narrow":"eyebrow_narrow__YS15q"};